import React from "react";
import ReactDOM from "react-dom/client";

// CSS-ul paginilor rămâne global, în ordinea de dinainte de code splitting:
// unele fișiere definesc aceleași clase (ex. corporate.css și leisure.css),
// iar aspectul paginilor depinde de care regulă vine ultima.
import "./pages/informatiiutile/informatiiutile.css";
import "./pages/404/404.css";
import "./pages/corporate/corporate.css";
import "./pages/leisure/leisure.css";
import "./components/grid-component/grid-component.css";
import "./components/grid-component/oferte-component.css";

import App from "./App";

// Fonturile găzduite pe server (înainte: @import din Google Fonts, care bloca afișarea)
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/400.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/700.css";
import "@fontsource/montserrat/500.css";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
